// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__JrfzY","footer":"ChangeClinic_footer__2P9lA"};